import Container from "./Container";
import {moveImageBox} from "../helpers/animations";
import {useEffect, useRef} from "react";
import ImageComparison from "./ImageComparison";
import julianImage1 from "../public/img/about/julian1.jpg";
import julianImage2 from "../public/img/about/julian2.jpg";
import localized from "../locale/locales";
import {useRouter} from "next/router";

export default function OwnerBlock() {
    const {locale} = useRouter();
    const {aboutUs: lang} = localized[locale];

    const refImage = useRef();
    const refBox = useRef();

    useEffect(() => {
        const handleScroll = () => {
            if (refImage.current && refBox.current) {
                moveImageBox(refImage, refBox, 0.1, -0.1);
            }
        };

        window?.addEventListener('scroll', handleScroll);
        handleScroll();

        return () => window?.removeEventListener('scroll', handleScroll);
    }, []);


    return (
        <Container className="py-16 md:pt-24 md:pb-32 flex flex-col-reverse md:flex-row items-center gap-10">
            <div className="flex-[1.3] relative">
                <div
                    className="hidden md:block w-[55%] h-[80%] absolute top-1/3 right-[10%] bg-white shadow-lg rounded-md ease-out transition-transform duration-500"
                    ref={refBox}
                />

                <div className="flex max-w-[500px] rounded-md overflow-hidden" ref={refImage}>
                    <ImageComparison before={julianImage1} after={julianImage2}/>
                </div>
            </div>

            <div className="flex-1 flex flex-col gap-4 w-full">
                <header className="flex flex-col gap-1">
                    <p className="text-xs text-gray-400 font-semibold uppercase">CEO & Founder</p>
                    <h2 className="text-3xl font-semibold">Julián Jančík</h2>
                </header>
                <p className="md:text-lg leading-loose md:leading-relaxed max-w-[28ch]">
                    {lang.owner.quote}
                </p>
            </div>
        </Container>
    )
}
